<template>
  <div style="padding:10px">
    <van-field v-model="fieldValue" center is-link readonly placeholder="Tahsilat Tipi" @click="show = true" left-icon="cluster-o" :rules="[{ required: true, message: 'Tip Gerekli' }]"/>
    <van-popup v-model="show" position="bottom"
      :style="{ height: '70%', margin: '10px auto auto auto', padding: '10px' }">
      <van-cascader v-model="sendObje.cari" :options="options" @close="show = false" @change="onChange"
        @finish="onFinish" />
    </van-popup>
    <van-field v-model="sendObje.aciklama.hasta" placeholder="Tahsilat Miktarı" type="number" left-icon="balance-o"/>



  

    <van-field type="textarea" placeholder="Message" rows="1" autosize v-model="sendObje.aciklama.message"  left-icon="notes-o"/>

    <van-divider>Evrak Yükle</van-divider>
    <van-uploader style="margin:20px" v-model="fileList" :after-read="afterRead">
      <template #preview-cover="{ file }">
        <div class="preview-cover van-ellipsis">{{ file.name }}</div>
      </template>
    </van-uploader> 
    <van-button block type="pure" color="#002375" native-type="submit" @click="shadd">
      KAYDET
    </van-button>
    <van-notice-bar v-if="err.msg !=''" color="#fff" background="#FFA384">{{err.msg}}</van-notice-bar>

    <van-popup v-model="bitti" :style="{ height: '100%', width:'100%' }"> 
      <van-icon size="180" :name="err.icon" />
      <div class="van-ellipsis" style="text-align:center; font-size: 28px; margin-bottom:60px; margin-top: 20px;">{{ err.msg }}</div>
      <van-button type="info" block size="small" to="uygulamalar" color="#002375"> UYGULAMALARIM </van-button>

    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      show2: false,
      options: [
        {text:'Fiziksel Pos',value:'1'},
        {text:'Sanal Pos',value:'2'},
        {text:'Nakit',value:'3'},
        {text:'Çek',value:'4'},
        {text:'Senet',value:'5'},
        {text:'Havele/Eft',value:'6'},
      ],
        
      fieldValue: '',
      sendObje: {
        cari: '', // kurum
        guid: '',
        miktar: '',
        tip:"Satış", // alış satış
        ay:this.$helper.setFiltre().aylik.sadeceay,
        yil:this.$helper.setFiltre().yillik.aktifYil,
        aciklama:{
          message:'',
          hasta:'',
          lot:[]
        },
        kod:'', // klasörleme sistemi için ekledik
      },
      fileList:[],
      bitti:false,
      err:{
        msg:'',
        icon:'',
        link:''
      }

    };
  },
  created() {
    this.$store.commit('setMenu',false)
    this.$store.commit("setLoading",[false,'...'])

  },
  methods: {

    lotAktar(index) {
      let giden = parseInt(index+1);
      this.sendObje.aciklama.lot[giden].text = this.sendObje.aciklama.lot[index].text
    },
    shadd(){
      // this.err.msg ="";
      //   if (this.sendObje.cari =="") {
      //               this.err.msg = "Bölge/Kurum Boş Geçilemez";
      //               this.err.icon = 'close';
      //               this.err.link =false;
      //               this.$store.commit("setLoading",[false,'...'])          
      //    } else if (this.sendObje.guid =="") {
      //               this.err.msg = "Ürün/Adet Boş Geçilemez";
      //               this.err.icon = 'close';
      //               this.err.link =false;
      //               this.$store.commit("setLoading",[false,'...'])           

      //         }
      //       else {
      //         this.$store.commit("setLoading",[true,'Bekleyiniz'])
      //           this.$store.dispatch('addstokHareket', { request: this.$request, obje: this.sendObje}).then(res => {
      //             if(res.status==200) {
      //               this.upload(res.id)
      //             }

      //           }).catch(err=>{

      //             if(err.status==500) {
      //               this.bitti=true
      //               this.err.msg = err.mesaj;
      //               this.err.icon = 'close';
      //               this.err.link =false;
      //               this.$store.commit("setLoading",[false,'...'])
      //             }
      //             else{
      //               this.$router.push("/oturum")

      //             }

      //           })
      //       }
    },
    birlestir(obj){
      return new Promise((resolve, reject) => {
      let lot = obj.lot.map((option) => option.text).join(',');
        resolve(lot)
    });

    },
    onChange({ value }) {
      //if (value === this.options[0].value) {
      setTimeout(() => {
        this.options[value].children = this.option[value].children;
      }, 500);
      //}
    },
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join('/');

    },
    onChange2({ value }) {
      //if (value === this.options[0].value) {
      setTimeout(() => {
        this.options2[value].children = this.option2[value].children;
      }, 500);
      //}
    },
    onFinish2({ selectedOptions }) {
      this.sendObje.aciklama.lot = [];
      this.show2 = false;
      this.fieldValue2 = selectedOptions.map((option) => option.text).join('/');
      // this.sendObje.guid =selectedOptions.map((option) => option.guid);
      this.sendObje.guid =selectedOptions[0].guid;
      this.sendObje.kod =selectedOptions[0].kod

      for (let i = 0; i < this.sendObje.miktar; i++) {
        this.sendObje.aciklama.lot.push({
          sira:i,
          text:""
        })
      } 
    },

    afterRead(file) {
      let index = this.fileList.findIndex(obj => obj.file.name === file.file.name);
      Object.assign(this.fileList[index], {name:file.file.name})
    },    
    upload(id) {

      this.$store.commit("setLoading",[true,'Evrak Ekleniyor'])

      let giden = {
        dir: ['stok',this.sendObje.kod,id],
        list: this.fileList,
        request: this.$request
      }
      this.$store.dispatch('upload', giden).then(res => {

        this.fileList = [];
        this.$store.commit("setLoading",[false,'Tamamlandı'])
        this.bitti=true
          this.err.msg = "İşlem Başarılı";
          this.err.icon = 'https://egemyazilim.com/success.png';
          this.err.link ='/uygulamalar';
          this.$store.commit("setLoading",[false,'...'])
      })
    },    

  },
};
</script>
<style>
.van-cell .van-field{
  background-color:#E5E9EC !important;
  height: 65px;
  font-size:90px !important
  
}
.van-icon-passed{
  margin-top: 80px;
  color: rgb(104, 211, 104) !important;
  text-align:center !important;
  display: block !important;
}

.van-icon-close{
  margin-top: 80px;
  color: rgb(175, 36, 32) !important;
  text-align:center !important;
  display: block !important;
}

.van-cascader__close-icon {
  color: #484848;
  font-size: 22px;
}
.van-cell__right-icon,.van-icon-down{
  color:#484848 !important;
  font-size:17px !important;
}
.van-cascader__option {
  padding: 5px 16px;
  font-size: 16px !important;
  line-height: 25px !important;
  background: #f2f2f2;
  margin: 10px 0
}

.van-field__control {
  font-size: 15px;
  margin-left:15px
}
.van-cascader__selected-icon{
  color:#002375 !important
}
</style>


// WEBPACK FOOTER //
// src/views/tahsilat.vue